/*
 * Modal that requires user to confirm an action they're about to take.
 *
 * As a design principle, you should set the confirmText prop to tell the user what action they're about to take.
 * For example, if they're about to delete an address, confirmText should be "Delete Address".
 */

import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const ConfirmActionModal = ({
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  mainText = 'Are you sure?',
  subText = null,
  onConfirm,
  onCancel,
  open = true,
  ...props
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...props}
    >
      <DialogTitle id="alert-dialog-title">{mainText}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {subText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary">
          {cancelText}
        </Button>
        <Button onClick={onConfirm} color="primary" autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmActionModal;
